<app-alerts></app-alerts>


<div  *ngIf="!loading; else load" class="row">
	<div class="col-12">
 
           <nb-card>
           <nb-card-header style="border-bottom:0 !important;">
                Мої витрати і поповнення
           </nb-card-header>
           	<nb-card-body style="
    margin: 0px !important;
    padding: 0px !important;
">


			 
 			 <table class="table  table-hover" *ngIf="items">

		<thead >
		<tr><td>Дата</td> <td></td><td class="hidden-mob">Тариф</td> <td>Сума</td>   </tr>
		</thead>
		<tbody >
		<tr *ngFor="let item of items">
			<td>{{item.date | dateFormattedPipe : 'noSeconds' }}</td>
 
			<td>{{item.description}}</td>
			<td>{{item.tarif_info}}</td>
			<td [class]=" item.isBalancePayment ? 'text-success' : ''" ><span *ngIf="item.amount !== 0">{{ item.isBalancePayment ? '+' : '-'}} {{item.amount | number:'1.2' }} грн.</span></td>
				 
		</tr>

		</tbody>
		</table>
		  
        	</nb-card-body>
           </nb-card> 
      
	</div>

</div>


<ng-template #load>
   <app-skeleton-page [height]="'900px'" [type]="'table'" ></app-skeleton-page>

   
</ng-template> 

